import { createFileRoute } from '@tanstack/react-router'
import EditUserGeneral from 'Administration/components/access/EditUserGeneral'

export const Route = createFileRoute('/administration/users/$id/general')({
    component: EditUserGeneral,
})
